import {
  CALENDAR_SET_VIEW,
  CALENDAR_SET_DATE,
  CALENDAR_SET_SELECTED_AGENDAS,
  CALENDAR_SET_FILTERS,
  CALENDAR_SET_LOADING,
  CALENDAR_SET_ERROR,
  CALENDAR_CLEAR_ERROR,
  CALENDAR_VIEWS
} from './calendarTypes.js';

const initialState = {
  view: CALENDAR_VIEWS.MONTH,
  date: new Date(),
  selectedAgendas: [],
  filters: {
    dateRange: {
      start: null,
      end: null
    },
    status: [],
    attendees: [],
    deals: []
  },
  loading: false,
  error: null
};

const calendarReducer = (state = initialState, action) => {
  switch (action.type) {
    case CALENDAR_SET_VIEW:
      return {
        ...state,
        view: action.payload
      };
    
    case CALENDAR_SET_DATE:
      return {
        ...state,
        date: action.payload
      };
    
    case CALENDAR_SET_SELECTED_AGENDAS:
      return {
        ...state,
        selectedAgendas: action.payload
      };
    
    case CALENDAR_SET_FILTERS:
      return {
        ...state,
        filters: action.payload
      };
    
    case CALENDAR_SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    
    case CALENDAR_SET_ERROR:
      return {
        ...state,
        error: action.payload
      };
    
    case CALENDAR_CLEAR_ERROR:
      return {
        ...state,
        error: null
      };
    
    default:
      return state;
  }
};

export default calendarReducer;